import getCurrentWorkoutSelect from '../get-current'
import getStartedWorkoutSelect from '../get-started'

export default function getCurrentOrStartedWorkoutSelect (state) {
  const current = getCurrentWorkoutSelect(state)
  return current || getStartedWorkoutSelect(state)
}
